import SetupRmDlysjgSmsModal from './setup-rm-dlysjg-sms-modal.vue'
export default SetupRmDlysjgSmsModal
